import request from 'local_modules/request'
import { constants, modals } from 'helpers'
import { reducers, getState } from 'redux/core'
import actions from 'redux/actions'


const setFetching = (isFetching) => reducers.marketplace.adminScheduleInputPage.setFetching(isFetching)

const fetchLabels = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.tariffLabels + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminScheduleInputPage.setLabels(data))
    .catch((error) => console.log(error))
}

const fetchSchedule = ({ year, month }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.generateSchedule + `/${year}${month ? `/${month}` : ''}/${tool}`)
    .then(({ data }) => data)
    .then((data) => {
      if (!data.error) {
        reducers.marketplace.adminScheduleInputPage.setSchedule(data)
      }
      else {
        console.log(data)
      }
    })
    .catch((error) => console.log(error))
}

const generateSchedule = ({ labelId, year, month, day, count }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(
    constants.marketplace.generateSchedule + `/${year}/${month}/${day}/${count}/${tool}`,
    { pattern: { lbl: { id: labelId } } }
  )
    .then(({ data }) => data)
    .catch((error) => {
      actions.modals.open(modals.Dialog, {
        title: 'Ошибка',
        text: JSON.stringify({ error })
      })
      console.log(error)
    })
}


export default {
  setFetching,

  fetchLabels,
  fetchSchedule,

  generateSchedule,
}
